import { SavedSearchType } from "@shared/publicportal/contracts/ISavedSearch";
import { PPConstants } from "@shared/publicportal/constants";

export class PublicPortalRoutingService {
    public Root = "/publicportal";
    public AppName = PPConstants.AppName;
    public Login = "login";
    public ForgotPassword = "forgotPassword";
    public ChangePassword = "changePassword";
    public ResetPassword = "resetPassword";
    public Register = "register";
    public PlanningApplications = "planningapplications";
    public PlanningAppeals = "planningAppeals";
    public EnforcementAppeals = "enforcementAppeals";
    public EnforcementNotices = "enforcementNotices";
    public BuildingRegulations = "buildingRegulations";
    public CompetentPersonsScheme = "competentPersonsScheme";
    public PropertySearch = "propertySearch";
    public WeeklyLists = "weeklyLists";
    public Settings = "settings";
    public CollectedData = "collectedData";
    public UserSettings = "userSettings";
    public VerifyEmail = "verifyEmail";
    public VerifyConsultee = "verifyConsultee";
    public TermsAndConditions = "termsAndConditions";

    public LoginRoute() {
        return this.toRoute(this.Root, this.Login);
    }
    public ForgotPasswordRoute() {
        return this.toRoute(this.Root, this.ForgotPassword);
    }
    public ChangePasswordRoute() {
        return this.toRoute(this.Root, this.ChangePassword);
    }
    public ResetPasswordRoute() {
        return this.toRoute(this.Root, this.ResetPassword);
    }
    public RegisterRoute() {
        return this.toRoute(this.Root, this.Register);
    }
    public VerifyEmailRoute() {
        return this.toRoute(this.Root, this.VerifyEmail);
    }
    public VerifyConsulteeRoute() {
        return this.toRoute(this.Root, this.VerifyConsultee);
    }
    public TermsAndConditionsRoute() {
        return this.toRoute(this.Root, this.TermsAndConditions);
    }
    public PlanningApplicationsRoute() {
        return this.toRoute(this.Root, this.PlanningApplications);
    }
    public PlanningApplicationRecordRoute(id: number) {
        return this.toRoute(this.Root, this.PlanningApplications, id.toString());
    }
    public SearchRoute(searchType: SearchRouteType, params: string) {
        return this.toRoute(this.Root, searchType, `?${params}`);
    }
    public PlanningAppealsRecordRoute(id: number) {
        return this.toRoute(this.Root, this.PlanningAppeals, id.toString());
    }
    public EnforcementAppealsRecordRoute(id: number) {
        return this.toRoute(this.Root, this.EnforcementAppeals, id.toString());
    }
    public EnforcementNoticesRecordRoute(id: number) {
        return this.toRoute(this.Root, this.EnforcementNotices, id.toString());
    }
    public BuildingRegulationsRecordRoute(id: number) {
        return this.toRoute(this.Root, this.BuildingRegulations, id.toString());
    }
    public CompetentPersonsSchemeRecordRoute(id: number) {
        return this.toRoute(this.Root, this.CompetentPersonsScheme, id.toString());
    }
    public CollectedDataRoute() {
        return this.toRoute(this.Root, this.CollectedData);
    }
    public UserSettingsRoute() {
        return this.toRoute(this.Root, this.UserSettings);
    }

    toRoute(...parts: string[]) {
        return parts.join("/");
    }
}

type SearchRouteType = SavedSearchType | "WeeklyLists";
